import { enableProdMode, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { withNgxsRouterPlugin, RouterStateSerializer } from '@ngxs/router-plugin';
import { provideStore } from '@ngxs/store';
import { withNgxsLoggerPlugin } from '@ngxs/logger-plugin';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import { initializeApp } from './app/app-initializer';
import {
    httpRequestInterceptor,
    CustomRouterStateSerializer,
    LazyTranslateLoader,
    NOTIFICATION_SERVICE,
    provideMsal,
    provideMaterial,
} from '@pecan/core';
import { SnackBarService } from '@pecan/shared/services/snack-bar.service';
import { providePermissions } from '@pecan/entities/permissions';
import { provideLocation } from '@pecan/entities/location';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideAnimationsAsync(),
        provideRouter(APP_ROUTES),
        provideStore(
            [],
            withNgxsLoggerPlugin({ disabled: environment.production }),
            withNgxsReduxDevtoolsPlugin({ disabled: environment.production }),
            withNgxsRouterPlugin()
        ),
        provideLocation(),
        providePermissions(),
        provideTranslateService({
            fallbackLang: 'en',
            lang: 'en',
            loader: {
                provide: TranslateLoader,
                useClass: LazyTranslateLoader,
            },
        }),
        provideZoneChangeDetection(),
        provideEnvironmentNgxMask(),
        provideHttpClient(withXhr(), withInterceptors([httpRequestInterceptor]), withInterceptorsFromDi()),
        provideAppInitializer(initializeApp),
        { provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
        { provide: NOTIFICATION_SERVICE, useExisting: SnackBarService },
        provideMaterial(),
        provideMsal(),
    ],
}).catch((err: Error) => console.error(err));
